// @ts-strict-ignore
import React, { useContext } from 'react';

import { RuleEditorContext } from 'flow/editor/components/NodeEditorDrawer/context';

import RuleLineItem from './RuleLineItem';
import RuleClause from './RuleClause';


interface Props {
  editable: boolean;
}

export default function RuleLinesContainer({
  editable,
}: Props) {
  const {
    semanticLineBreakData,
    isMatrixModelFocused,
    setIsMatrixModelFocused,
  } = useContext(RuleEditorContext);

  return semanticLineBreakData?.groupedByLines?.length > 0
    ? (
      <div onFocus={() => isMatrixModelFocused && setIsMatrixModelFocused(false)}>
        {semanticLineBreakData?.groupedByLines.map((lineData, lineIndex) => (
          <RuleLineItem
            editable={editable}
            key={lineData.id}
            lineIndex={lineIndex}
          />
        ))}
      </div>
    )
    : (
      <RuleClause />
    );
}
